import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';
import { emptyObject } from 'ui-components/default-props/empty';

import FormattedCurrency from '../../../../../../../components/formatted-currency/container';
import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { CurrencyPropType } from '../../../../../../../prop-types/currency';
import { messages } from '../messages';

import style from '../manage-add-ons.module.less';

const AddOnPriceColumnId = 'addOnPrice';

const addOnPriceBuilder = ({ price }) => {
  return price;
};

const AddOnPriceCell = ({ cell }) => {
  const { code, value } = cell.value || emptyObject;

  const currencyValue = value ? Math.abs(parseFloat(value)) : 0;

  return (
    <Text
      className={style['add-on-price']}
      textType={TextType.Paragraph}
      value={<FormattedCurrency currencyCode={code} value={currencyValue} />}
    />
  );
};

AddOnPriceCell.propTypes = {
  cell: PropTypes.shape({
    value: CurrencyPropType,
  }).isRequired,
};

const createAddOnPriceColumnDefinition = createColumnDefinitionBuilder({
  Header: <FormattedMessage {...messages.price} />,
  accessor: AddOnPriceColumnId,
  Cell: AddOnPriceCell,
  width: 1,
  className: style['justify-end'],
});

export { AddOnPriceColumnId, addOnPriceBuilder, createAddOnPriceColumnDefinition };
